module.exports = __webpack_public_path__ + "img/zoe_estates_bg_room_002.4d23f459.jpg";